import { Injectable, Inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { MenuItem } from '@awp/models';
import { getMenuRoute } from '@awp/core/ngrx';
import { MenuService, MENU_TOKEN } from '@awp/app-common';

@Injectable({
  providedIn: 'root'
})
export class CurrentMenuQuery {

  constructor(
    private store: Store<any>,
    @Inject(MENU_TOKEN) private menuService: MenuService) { }

  get values(): Observable<MenuItem> {
    return this.store
      .pipe(
        select(getMenuRoute),
        withLatestFrom(this.menuService.values),
        map(([menuId, menuItems]) => {
          return menuItems.find(p => p.url === menuId);
        })
      );
  }
}